import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../../../generated/auth/services/reference.service';
import { loadIdTypeList, loadListFailure, loadListSuccess, toggleLoadingStatus } from './store.actions';
import { selectIdTypeIsLoading, selectIdTypeList } from './store.selectors';

@Injectable()
export class UIEffect {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadCountryList = createEffect(() =>
    this.action.pipe(
      ofType(loadIdTypeList),
      withLatestFrom(this.store.select(selectIdTypeList), this.store.select(selectIdTypeIsLoading)),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceLookupGetIdentificationTypesGet().pipe(
          switchMap((response) => of(loadListSuccess({ payload: response.result }))),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}
